module.exports = __webpack_public_path__ + "media/images/plissees_660-00a6131c611fd2e96efaa2be71fa68be.jpg";